export default "__VITE_ASSET__BrJV4u1y__"